import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { updateIndicator } from 'app/redux/store/features/configs'
import { getSectionById, selectItemById, updateSection } from 'app/redux/store/features/sections'
import UpdateSectionForm from './UpdateSectionForm'

const UpdateSection = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { state } = useLocation()
    const { classId, sectionId } = state
    const { sections, loading, error } = useSelector((state) => state.sections)
    const section = selectItemById(sections, sectionId)
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const [sectionData, setSectionData] = useState({})
    const loadedSectionIdRef = useRef(null)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(section.sectionId)) {
            dispatch(getSectionById({ classId: classId, id: sectionId }))
        }
    }, [])

    useEffect(() => {
        if (section?.id && loadedSectionIdRef.current !== section.id) {
            loadedSectionIdRef.current = section.id
            const rawAdditionalIds = Array.isArray(section.additionalTeachers)
                ? section.additionalTeachers
                      .map((t) => t?.id ?? t?.Id)
                      .filter((id) => id != null && id !== '')
                      .map((id) => String(id))
                : Array.isArray(section.additionalTeacherIds)
                  ? section.additionalTeacherIds.map((id) => String(id))
                  : []
            setSectionData({
                ...section,
                additionalTeacherIds: utilServices.sanitizeAdditionalTeacherIds(section, rawAdditionalIds),
            })
        }
    }, [section])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Section updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            dispatch(updateIndicator({ inProgress: false }))
            navigate('/courses/setup/classes', { state: { navigateFrom: 'update-section' } })
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const effectiveSectionData = section?.id ? sectionData : section

    return (
        <React.Fragment>
            <UpdateSectionForm sectionData={effectiveSectionData} setApiCallInProgress={setApiCallInProgress} />
        </React.Fragment>
    )
}

export default UpdateSection
